import React from "react";
import "./Steel.css";

function Steel() {
  return (
    <div className="steelmain">
      <div className="feedback">
        <div className="steelpp">
          <p>Steel Industry chain Application</p>
          <div>
            {/* <p className="s3"><abbr title="Go To Swajit Engineering Pvt.Ltd">Swajit Engineering Pvt.Ltd:/</abbr>
          <a href="https://www.swajit.com/"></a> >Steel Industry</p> */}
          </div>
        </div>
        <div className="section3">
          <iframe
            className="steels3"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/bVRjBQRSYAk"
            title="I Beam Manufacturing Process"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          <iframe
            className="steels3"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/74GIgHnertE"
            title="Cold Rolling Mill"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div className="section4">
          <iframe
            className="steels3"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/nvaz3WidGmo"
            title="Hot Strip Mill"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          <iframe
            className="steels3"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/CPkDyTKp3kQ"
            title="SinteringPlant"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div className="section5">
          <iframe
            className="steels3"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/ykENjactybs"
            title="ContinousCastingPlantCCP"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default Steel;
